/**
 * Ad-tracking consent. Visitors in Europe (EU/EEA/UK, told apart by their time
 * zone) are asked first and nothing loads until they accept; everyone else is
 * covered by the Privacy Policy and tracked by default.
 */
const KEY = 'loomia.adConsent';

export function needsConsentPrompt(): boolean {
  return isEurope() && stored() === null;
}

function isEurope(): boolean {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone ?? '';
    return tz.startsWith('Europe/') || tz === 'Atlantic/Reykjavik' || tz === 'Atlantic/Canary' || tz === 'Atlantic/Madeira';
  } catch {
    return false;
  }
}

function stored(): boolean | null {
  try {
    const v = localStorage.getItem(KEY);
    return v === null ? null : v === 'yes';
  } catch {
    return null;
  }
}

export function setAdConsent(yes: boolean): void {
  try {
    localStorage.setItem(KEY, yes ? 'yes' : 'no');
  } catch {
    // Private mode: asked again next visit.
  }
}

/** True when ad pixels may run and conversions may be sent for this visitor. */
export function adConsent(): boolean {
  return isEurope() ? stored() === true : stored() !== false;
}
